import React from 'react';
import styles from './styles.module.css';
import { useSlidesContent } from '../../../context/SlidesContentContext';
import { SlideTitle } from '../slide-title';

export type TableOfContentsProps = [
  {
    field: 'title';
    label: string;
    value: string;
    type: 'text';
  },
];

export const TableOfContents = React.memo((): React.ReactElement => {
  const { slides } = useSlidesContent();

  const filteredSlides = slides.filter(slide => {
    const tableOfContents = slide.content.find(
      content => content.field === 'table_of_contents',
    )?.value;
    return tableOfContents === true;
  });

  return (
    <div className={styles.cover}>
      <SlideTitle style={{ marginBottom: '30px' }}>Contents</SlideTitle>
      <div className={styles.contentList}>
        <div className={styles.firstLevel}>
          {filteredSlides.map(slide => (
            <div className={styles.item} key={slide.slideTemplateId}>
              <span className={styles.text}>
                {slide.content.find(
                  content => content.field === 'abbreviated_model_set_name',
                )?.value ? (
                  <b>
                    {
                      slide.content.find(
                        content =>
                          content.field === 'abbreviated_model_set_name',
                      )?.value
                    }
                  </b>
                ) : (
                  slide.content.find(content => content.field === 'title')
                    ?.value
                )}
              </span>
              <span className={styles.dots}></span>
              <span className={styles.number}>{slide.slideTemplateId}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
});
